import script from "./Page5-1-2.vue?vue&type=script&setup=true&lang=js"
export * from "./Page5-1-2.vue?vue&type=script&setup=true&lang=js"

import "./Page5-1-2.vue?vue&type=style&index=0&id=2c57b410&scoped=true&lang=css"

import exportComponent from "/Users/whn/Desktop/views/vue-gsap/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.17_vue@3.5.17_typescript@5.8.3__webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c57b410"]])

export default __exports__